import path from 'node:path';
import kebabCase from 'lodash/kebabCase.js';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import { getBlocksWidgetsDir, PANELS_DIR } from '@wix/cli-app-definitions';

const BLOCKS_WIDGET_TEMPLATE = path.resolve(
  __dirname,
  '../templates/blocks-widget'
);

const BLOCKS_WIDGET_PANEL_TEMPLATE = path.resolve(
  __dirname,
  '../templates/blocks-widget-panel'
);

export async function generateBlocksWidget(
  projectFolder: string,
  id: string,
  name: string
) {
  const cwd = path.join(getBlocksWidgetsDir(projectFolder), kebabCase(name));
  const widgetConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/blocks-widget.json',
    id,
  };
  const widgetConfigJSON = toJsonString(widgetConfig, { spaces: 2 });

  return componentGenerator({
    template: BLOCKS_WIDGET_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      id,
      name,
      widgetConfigJSON,
    },
  });
}

export async function generateBlocksWidgetPanel(
  projectFolder: string,
  id: string,
  name: string,
  widgetName: string
) {
  const cwd = path.join(
    getBlocksWidgetsDir(projectFolder),
    kebabCase(widgetName),
    PANELS_DIR,
    kebabCase(name)
  );
  const panelConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/blocks-widget-panel.json',
    id,
  };
  const panelConfigJSON = toJsonString(panelConfig, { spaces: 2 });

  return componentGenerator({
    template: BLOCKS_WIDGET_PANEL_TEMPLATE,
    projectFolder,
    cwd,
    data: { id, name, panelConfigJSON },
  });
}
